<template>
  <header class="sticky top-0 lg:top-10 z-40">
    <div class="sm:h-[105px] flex flex-col p-4 lg:px-8 lg:py-6  bg-[#000000]">
      <div class="w-full flex justify-between items-center">
        <div class="flex gap-8 items-center justify-between sm:justify-normal grow sm:grow-1">
          <router-link to="/" class="block">
            <img class="h-6 sm:h-auto" src="/stima/assets/images/logo.svg" alt="Stima">
          </router-link>
          <div id="nav-handle" class="sidebar-handle"></div>
        </div>

        <div class="hidden sm:block">
          <button class="login-btn">Log in</button>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'Head',
}
</script>